import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useAlertStore } from '@/stores'

export const useWatchlistStore = defineStore('watchlist', () => {
  //initialize from localstorage (array of projectIds)
  //const watching = ref<Array<Number> | null>(JSON.parse(localStorage.getItem('watching')) || [20210001]) //string of JSON

  const watching = computed(()=>{
    return JSON.parse(localStorage.getItem('watching')) || [];
  })

  const isEmpty = computed(() => {
   //if (watching.value) {
      if (watching.value.length > 0) {
        return false
      } else {
        return true
      }
  //  } else {
   //   return true
   // }
  })

  function isWatched(projectId: number) {
    //if (watching.value && watching.value!=null && watching.value.includes(projectId)) {
    if (watching.value.includes(projectId)){
      return true
    }
    return false
  }

  /**
   * add a project to the watchlist, if not already present
   * @param projectId
   */
  async function add(projectId: number) {
    const alert = useAlertStore()
    let temp = []
    if (!isEmpty.value) {
      temp = watching.value
    }
    //const temp = watching.value;
    if (!watching.value.includes(projectId)){
      temp.push(projectId)
      localStorage.setItem('watching', JSON.stringify(temp))
      watching.value = temp;
      alert.success(projectId + ' added to watchlist')
      setTimeout(() => {
        alert.clear()
      }, 2000)
    }
    
  }

  /**
   * remove a project from the watchlist
   * @param projectId
   */
  async function remove(projectId: number) {
    console.log('watchlist store remove() ' + projectId)
    const index = watching.value.indexOf(projectId)
    console.log('index in watching = ' + index)
    //const temp = watching.value;
    if (watching.value.includes(projectId)) {
      //let temp = watching.value;
      const temp = watching.value.filter((id) => {
        return id != projectId
      })
      localStorage.setItem('watching', JSON.stringify(temp))
      watching.value = temp
      const alert = useAlertStore()
      alert.success(projectId + ' removed from watchlist')
      setTimeout(() => {
        alert.clear()
      }, 2000)
    }
  }

  return { watching, isEmpty, isWatched, add, remove }
})
